import React, { InputHTMLAttributes, forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, icon, fullWidth, className, ...props }, ref) => {
    return (
      <div className={classNames(styles.inputWrapper, { [styles.fullWidth]: fullWidth })}>
        {label && <label className={styles.label}>{label}</label>}
        
        <div className={styles.inputContainer}>
          {icon && <div className={styles.icon}>{icon}</div>}
          <input
            ref={ref}
            className={classNames(
              styles.input,
              {
                [styles.error]: error,
                [styles.withIcon]: icon,
              },
              className
            )}
            {...props}
          />
        </div>

        {error && <span className={styles.errorText}>{error}</span>}
        {helperText && !error && <span className={styles.helperText}>{helperText}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;